import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@/store';
import { Admin } from '@/types/admin';
import { authStore } from '@/store/auth';
import { pages } from '@/settings/pages';
import { affiliationsAdminApi } from '@/services/api';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

import { NameEditForm } from '../Presentation';
import { Loading } from '@/components/utils/Loading';
import { useCheckAuthorizationFreshness } from '@/hooks/useCheckAuthorizationFreshness';

export const NameEditFormContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { apiErrorHandler } = useApiErrorHandler();
  const { flashNotice } = useFlashMessenger();
  const organizationId = useAppSelector(
    authStore.selectors.organizationIdSelector,
  );
  const admin = useAppSelector(authStore.selectors.meSelector);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const checkAuthorizationFreshness = useCheckAuthorizationFreshness(
    setIsLoading,
    pages.account.name.edit,
  );

  useEffect(() => {
    checkAuthorizationFreshness();
  }, [checkAuthorizationFreshness]);

  const onSubmit = async (admin: Admin) => {
    try {
      setIsLoading(true);
      const affiliation = await affiliationsAdminApi.updateName({
        data: {
          admin,
          organizationId,
        },
      });
      dispatch(authStore.actions.updateMe(affiliation.admin));
      flashNotice(t('text.account.name.edit.done'));
      navigate(pages.account.index);
    } catch (err) {
      setIsLoading(false);
      apiErrorHandler(err, pages.account.name.edit);
    }
  };

  const childProps = { admin, isLoading, onSubmit };
  return isLoading ? <Loading /> : <NameEditForm {...childProps} />;
};
